import React, { ReactNode } from 'react';

interface TabProps {
  children: ReactNode;
  className?: string;
  active?: boolean;
  eventKey?: string;
  label: string | JSX.Element;
}

const Tab: React.FC<TabProps> = ({ children, className, active }) => {
  return (
    <>
    {React.Children.map(children, (child, index) => {

      if (React.isValidElement(child)) {
        return (
          <div className={className}>
            {React.cloneElement(child as React.ReactElement<any>, { visible: `${active}` })}
          </div>
        )
      } else {
        return null;
      }
    })}
  </>
  )
};

export default Tab;